<!--留言-->
<template>
  <el-dialog :title="showtitle"
             :visible.sync="dialogFormVisible"
             custom-class="mini-dialog"
             center
             :append-to-body="true"
             :close-on-click-modal="false"
             :modal="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-form-item label="" label-width="0" prop="liuyan" size="small">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" v-model="form.liuyan" auto-complete="off"
                  :required="true"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="addMessage" class="qrbtn">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updateliuyan} from '@/api/set/csagreement';
  import {saveData} from '@/api/set/handlelog';

  export default {
    name: "DataContactEdit",
    data() {
      var checkrequired = (rule, value, callback) => {
        if (value.replace(/(^\s*)|(\s*$)/g, "") === '') {
          callback(new Error('必填！'));
        } else {
          callback();
        }
      };

      return {
        dialogFormVisible: false,
        showtitle: '',
        erpserial: '',
        hd_status: null,
        form: {
          remark: '',
          liuyan: '',
          unitguid: '',
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          liuyan: [
            {validator: checkrequired, trigger: 'blur'}
          ],
        },
      }
    },
    methods: {
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = this.hd_status==200?'退回订单岗':this.hd_status==650?"退回客服岗":""
        if(handlelog.casestepname=='')
          return;
        handlelog.remark = this.form.liuyan
        saveData(handlelog).then(response => {
        })
      },
      show(item, showtitle, hd_status) {
        this.initForm();
        if (showtitle == null || showtitle == '')
          showtitle = '备注';
        this.showtitle = showtitle;
        this.hd_status = hd_status;
        this.form.unitguid = item.unitguid;
        this.form.remark = item.remark;
        this.erpserial = item.erpserial;
        this.dialogFormVisible = true;
      },
      addMessage() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            updateliuyan(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.handlelog();
              }
              this.dialogFormVisible = false
              //刷新列表
              this.$emit("afterLiuYan", response.data.remark, this.form.unitguid, this.hd_status,this.erpserial)
            });
          }
        })
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.form.liuyan='';
      }
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/LiuYanEdit.vue